import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const PURCHASES = [{
  name: 'Martín',
  city: 'Buenos Aires'
}, {
  name: 'Laura',
  city: 'Córdoba'
}, {
  name: 'Diego',
  city: 'Rosario'
}, {
  name: 'Pablo',
  city: 'Mendoza'
}, {
  name: 'Silvia',
  city: 'La Plata'
}, {
  name: 'Gustavo',
  city: 'Mar del Plata'
}, {
  name: 'Ana',
  city: 'Santa Fe'
}];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPurchase);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 5000);
    // Repeat every 20 seconds
    const interval = setInterval(showPopup, 20000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-172">
      <div className="bg-white rounded-lg shadow-xl border border-gray-200 p-4 flex items-center gap-3 max-w-xs" data-id="element-173">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-174">
          <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-175" />
        </div>
        <div data-id="element-176">
          <p className="text-sm font-bold text-gray-900" data-id="element-177">
            {currentPurchase.name} de {currentPurchase.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-178">
            compró el Megapack hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}